import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Image from 'next/image';
import { getYear } from '@@client/lib/dates';
import { useTokenCache } from '@@client/lib/hooks';
import { newsletterSignup } from '@@client/newsletter/actions';
import Messages from '@@client/components/Messages';
import NewsletterForm from '@@client/newsletter/NewsletterForm';
import Col100 from '@@client/components/Col100';
import SlideOpen from './SlideOpen';
import LinksAboutUs from './footer/LinksAboutUs';
import LinksContactUs from './footer/LinksContactUs';
import LinksCustomerResources from './footer/LinksCustomerResources';
import LinksFindUsedParts from './footer/LinksFindUsedParts';
import LinksSellAVehicle from './footer/LinksSellAVehicle';
import LinksUserInformation from './footer/LinksUserInformation';
var year = getYear();

var mapStateToProps = function mapStateToProps(_ref) {
  var config = _ref.config,
      chat = _ref.chat,
      newsletter = _ref.newsletter;
  return {
    config: config,
    chat: chat,
    newsletter: newsletter
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({
      newsletterSignup: newsletterSignup
    }, dispatch)
  };
};

var Footer = function Footer(_ref2) {
  var config = _ref2.config,
      chat = _ref2.chat,
      newsletter = _ref2.newsletter,
      actions = _ref2.actions;
  var tokenCache = useTokenCache();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("footer", {
      className: "jsx-2474151685",
      children: /*#__PURE__*/_jsxs(Col100, {
        children: [/*#__PURE__*/_jsxs("nav", {
          "aria-label": "Footer navigation",
          className: "jsx-2474151685" + " " + 'a-sm',
          children: [/*#__PURE__*/_jsxs("div", {
            className: "jsx-2474151685",
            children: [/*#__PURE__*/_jsx("h4", {
              className: "jsx-2474151685",
              children: "About Us"
            }), /*#__PURE__*/_jsx(LinksAboutUs, {})]
          }), /*#__PURE__*/_jsxs("div", {
            className: "jsx-2474151685",
            children: [/*#__PURE__*/_jsx("h4", {
              className: "jsx-2474151685",
              children: "User Information"
            }), /*#__PURE__*/_jsx(LinksUserInformation, {})]
          }), /*#__PURE__*/_jsxs("div", {
            className: "jsx-2474151685",
            children: [/*#__PURE__*/_jsx("h4", {
              className: "jsx-2474151685",
              children: "Customer Resources"
            }), /*#__PURE__*/_jsx(LinksCustomerResources, {})]
          }), /*#__PURE__*/_jsxs("div", {
            className: "jsx-2474151685",
            children: [/*#__PURE__*/_jsx("h4", {
              className: "jsx-2474151685",
              children: "Find Used Parts"
            }), /*#__PURE__*/_jsx(LinksFindUsedParts, {})]
          }), /*#__PURE__*/_jsxs("div", {
            className: "jsx-2474151685",
            children: [/*#__PURE__*/_jsx("h4", {
              className: "jsx-2474151685",
              children: "Sell a Vehicle"
            }), /*#__PURE__*/_jsx(LinksSellAVehicle, {})]
          }), /*#__PURE__*/_jsxs("div", {
            className: "jsx-2474151685",
            children: [/*#__PURE__*/_jsx("h4", {
              className: "jsx-2474151685",
              children: "Contact Us"
            }), /*#__PURE__*/_jsx(LinksContactUs, {
              chatButtonClassName: "m--as-link"
            })]
          })]
        }), /*#__PURE__*/_jsxs("nav", {
          className: "jsx-2474151685" + " " + 't-xs',
          children: [/*#__PURE__*/_jsx(SlideOpen, {
            id: "footer-about-us",
            title: "About Us",
            children: /*#__PURE__*/_jsx(LinksAboutUs, {})
          }), /*#__PURE__*/_jsx(SlideOpen, {
            id: "footer-user-information",
            title: "User Information",
            children: /*#__PURE__*/_jsx(LinksUserInformation, {})
          }), /*#__PURE__*/_jsx(SlideOpen, {
            id: "footer-general-info",
            title: "Customer Resources",
            children: /*#__PURE__*/_jsx(LinksCustomerResources, {})
          }), /*#__PURE__*/_jsx(SlideOpen, {
            id: "footer-find-parts",
            title: "Find Used Parts",
            children: /*#__PURE__*/_jsx(LinksFindUsedParts, {})
          }), /*#__PURE__*/_jsx(SlideOpen, {
            id: "footer-sell-vehicle",
            title: "Sell a Vehicle",
            children: /*#__PURE__*/_jsx(LinksSellAVehicle, {})
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: "jsx-2474151685" + " " + 'copy-mail-social',
          children: [/*#__PURE__*/_jsxs("div", {
            className: "jsx-2474151685" + " " + 'copyright',
            children: ["\xA9 ", year, " B&R Autowrecking. All Rights Reserved."]
          }), /*#__PURE__*/_jsxs("div", {
            className: "jsx-2474151685" + " " + 'mail-social',
            children: [/*#__PURE__*/_jsx("div", {
              className: "jsx-2474151685" + " " + 'mail',
              children: !config.message.newsletterSignupEnabled ? null : /*#__PURE__*/_jsxs("div", {
                className: "jsx-2474151685",
                children: [/*#__PURE__*/_jsx("h4", {
                  className: "jsx-2474151685",
                  children: "Newsletter Signup"
                }), newsletter.isSignedUp ? /*#__PURE__*/_jsx(Messages, {
                  success: ["You're signed up."]
                }) : /*#__PURE__*/_jsxs(_Fragment, {
                  children: [/*#__PURE__*/_jsx(Messages, {
                    error: newsletter.errors
                  }), /*#__PURE__*/_jsx(NewsletterForm, {
                    idPrefix: "footer-newsletter",
                    disabled: newsletter.doing,
                    paramErrors: newsletter.paramErrors,
                    onSubmit: function onSubmit(_ref3) {
                      var name = _ref3.name,
                          email = _ref3.email;
                      return actions.newsletterSignup(tokenCache, {
                        name: name,
                        email: email
                      });
                    }
                  })]
                })]
              })
            }), /*#__PURE__*/_jsx("div", {
              className: "jsx-2474151685" + " " + 't-xs contact',
              children: /*#__PURE__*/_jsx(LinksContactUs, {
                linkClassName: "btn btn--blue--dark"
              })
            }), /*#__PURE__*/_jsxs("div", {
              className: "jsx-2474151685" + " " + 'social',
              children: [/*#__PURE__*/_jsx("h4", {
                className: "jsx-2474151685",
                children: "Follow Us"
              }), /*#__PURE__*/_jsxs("ul", {
                className: "jsx-2474151685",
                children: [/*#__PURE__*/_jsx("li", {
                  className: "jsx-2474151685",
                  children: /*#__PURE__*/_jsx("a", {
                    href: "https://www.facebook.com/autowrecking",
                    className: "jsx-2474151685",
                    children: /*#__PURE__*/_jsx(Image, {
                      width: "36",
                      height: "36",
                      src: "/images/icons/icon-social-fb.svg",
                      alt: "Facebook"
                    })
                  })
                }), /*#__PURE__*/_jsx("li", {
                  className: "jsx-2474151685",
                  children: /*#__PURE__*/_jsx("a", {
                    href: "https://twitter.com/br_autowrecking",
                    className: "jsx-2474151685",
                    children: /*#__PURE__*/_jsx(Image, {
                      width: "36",
                      height: "36",
                      src: "/images/icons/icon-social-twitter.svg",
                      alt: "Twitter"
                    })
                  })
                }), /*#__PURE__*/_jsx("li", {
                  className: "jsx-2474151685",
                  children: /*#__PURE__*/_jsx("a", {
                    href: "https://www.instagram.com/bandrautowrecking/",
                    className: "jsx-2474151685",
                    children: /*#__PURE__*/_jsx(Image, {
                      width: "36",
                      height: "36",
                      src: "/images/icons/icon-social-instagram.svg",
                      alt: "Instagram"
                    })
                  })
                }), /*#__PURE__*/_jsx("li", {
                  className: "jsx-2474151685",
                  children: /*#__PURE__*/_jsx("a", {
                    href: "https://www.linkedin.com/company/b&r-auto-wrecking",
                    className: "jsx-2474151685",
                    children: /*#__PURE__*/_jsx(Image, {
                      width: "36",
                      height: "36",
                      src: "/images/icons/icon-social-linkedin.svg",
                      alt: "LinkedIn"
                    })
                  })
                })]
              })]
            })]
          })]
        })]
      })
    }), /*#__PURE__*/_jsx(_JSXStyle, {
      id: "2474151685",
      children: ["footer.jsx-2474151685{position:relative;padding:34px 0;background:#252B40;color:white;-webkit-box-shadow:0 -2px 4px 0 rgba(0,0,0,0.5);box-shadow:0 -2px 4px 0 rgba(0,0,0,0.5);}", "@media(max-width:575px){footer.jsx-2474151685{padding:15px 0 30px 0;}}", "@media print{footer.jsx-2474151685{display:none;}}", "h4.jsx-2474151685{text-transform:uppercase;margin-bottom:14px;}", "@media(min-width:576px){nav.jsx-2474151685{display:grid;grid-template-columns:repeat(auto-fit,minmax(170px,1fr));grid-gap:30px;}}", "@media(min-width:992px){nav.jsx-2474151685{grid-template-columns:repeat(auto-fit,minmax(135px,1fr));}}", "@media(min-width:1200px){nav.jsx-2474151685{grid-template-columns:repeat(auto-fit,minmax(170px,1fr));}}", "nav.jsx-2474151685 .slide-open:first-child{border-top:0;}", "nav.jsx-2474151685 .slide-open:last-child{border-bottom-width:1px;}", "nav.jsx-2474151685 ul{list-style:none;margin:0;padding:0;}", "nav.jsx-2474151685 li{padding-left:20px;margin-bottom:14px;}", "@media(min-width:576px){nav.jsx-2474151685 li{padding-left:0;}}", "nav.jsx-2474151685 a,nav.jsx-2474151685 a:visited,nav.jsx-2474151685 .m--as-link{color:white;font-weight:400;-webkit-text-decoration:none;text-decoration:none;padding:0;}", "nav.jsx-2474151685 a:hover,nav.jsx-2474151685 .m--as-link:hover{color:#FFDD15;}", "nav.jsx-2474151685 button{text-transform:uppercase;font-weight:700;}", ".copy-mail-social.jsx-2474151685{display:-webkit-box;display:-ms-flexbox;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:reverse;-ms-flex-direction:column-reverse;-webkit-flex-direction:column-reverse;-ms-flex-direction:column-reverse;flex-direction:column-reverse;margin-top:30px;}", "@media(min-width:768px){.copy-mail-social.jsx-2474151685{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;}}", ".mail-social.jsx-2474151685{margin-bottom:30px;}", "@media(min-width:576px){.mail-social.jsx-2474151685{display:-webkit-box;display:-ms-flexbox;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;}}", "@media(min-width:768px){.mail-social.jsx-2474151685{margin-bottom:0;}}", ".copy-mail-social.jsx-2474151685 .contact.jsx-2474151685 ul{list-style:none;border-top:1px solid #9BA3C3;padding:20px 25px 0 25px;margin:20px 0 0 0;}", ".copy-mail-social.jsx-2474151685 .contact.jsx-2474151685 li{margin-bottom:15px;}", ".copy-mail-social.jsx-2474151685 .contact.jsx-2474151685 li:last-child{margin-bottom:0;}", ".copy-mail-social.jsx-2474151685 .contact.jsx-2474151685 .btn{width:100%;padding-left:20px;padding-right:20px;}", ".copyright.jsx-2474151685{-webkit-box-flex:1;-ms-flex-positive:1;-webkit-box-flex:1;-webkit-flex-grow:1;-ms-flex-positive:1;flex-grow:1;font-size:0.8125rem;color:#CCD0E0;margin-top:auto;}", "@media(max-width:575px){.copyright.jsx-2474151685{text-align:center;}}", ".mail.jsx-2474151685{max-width:305px;}", "@media(max-width:575px){.mail.jsx-2474151685{padding:0 8px;}}", "@media(min-width:576px){.mail.jsx-2474151685{min-width:205px;margin-right:40px;}}", "@media(max-width:575px){.mail.jsx-2474151685 .newsletter-fields{display:grid;grid-template-columns:1fr 1fr;grid-gap:10px;}}", "@media(max-width:400px){.mail.jsx-2474151685 .newsletter-fields{display:block;}}", "@media(max-width:575px){.mail.jsx-2474151685 form{padding:0 20px;}}", ".mail.jsx-2474151685 form button{display:block;padding:10px 15px;width:100%;}", "@media(max-width:575px){.social.jsx-2474151685{border-top:1px solid #9BA3C3;padding-top:20px;margin-top:20px;}}", "@media(max-width:575px){.social.jsx-2474151685 h4.jsx-2474151685{display:none;}}", ".social.jsx-2474151685 ul.jsx-2474151685{list-style:none;margin:0;padding:0;}", "@media(max-width:575px){.social.jsx-2474151685 ul.jsx-2474151685{padding:0 10px;text-align:center;}}", ".social.jsx-2474151685 li.jsx-2474151685{display:inline-block;margin-right:10px;}", "@media(max-width:575px){.social.jsx-2474151685 li.jsx-2474151685{margin-right:30px;}}", ".social.jsx-2474151685 li.jsx-2474151685:last-child{margin-right:0;}", ".social.jsx-2474151685 a.jsx-2474151685{display:block;}", ".social.jsx-2474151685 a.jsx-2474151685:hover{opacity:0.8;}"]
    })]
  });
};

export default connect(mapStateToProps, mapDispatchToProps)(Footer);